import React from "react";

export const  Spinner = (props ) => {
    
  let {
      // bgcolor, 
      type, 
      size,
      className
  } = props;

    let icon = '';

    switch ( type ) {
      case 'circle':
        icon = 'fa fa-circle-o-notch';
        break;
        case 'atom':
          icon = 'nc-icon nc-atom';
          break;
        case 'spinner':
          icon = 'fa fa-spinner';
          break;

      default:
        icon = 'nc-icon nc-refresh-69';
    }

    return (
    <i className={icon+"  fa-spin " + (size==="XL"?"h1":(size==="L"?"h3":"")) + " "+ className} />
    );
  }


